import Loading from "~/themes/cliente-pz/components/forms/Loading.vue";
import PrecompiledData from "~/themes/cliente-pz/components/forms/PrecompiledData.vue";
import PrecompiledDocument from "~/themes/cliente-pz/components/forms/PrecompiledDocument.vue";
import IdentityDocData from "~/components/forms/IdentityDocData.vue";
import IncomeData from "~/components/forms/IncomeData.vue";
import EmployerData from "~/components/forms/EmployerDataShort.vue";
import LoanProtection from "~/components/forms/LoanProtection.vue";
import LoanProtectionConsent from "~/components/forms/LoanProtectionConsent.vue";
import LoanProtectionWarning from "~/components/forms/LoanProtectionWarning.vue";
import ClubConsent from "~/components/forms/ClubConsent.vue";
import ClubWarning from "~/components/forms/ClubWarning.vue";
import PersonalData from "~/themes/cliente-pz/components/forms/PersonalDataPz.vue";
import Promo from "~/components/forms/Promo.vue";
import PromoConfirm from "~/components/forms/PromoConfirm.vue";
import PromoTerms from "~/components/forms/PromoTerms.vue";
import MetlifeProtection from "~/components/forms/MetlifeProtection.vue";
import MetlifeProtectionConsent from "~/components/forms/MetlifeProtectionConsent.vue";
import MetlifeProtectionWarning from "~/components/forms/MetlifeProtectionWarning.vue";
import RequestKO from "~/components/ko/RequestKO.vue";
import RequestPending from "~/components/ko/RequestPending.vue";
import RequestExpired from "~/components/ko/RequestExpired.vue";
import Typ from "~/components/typ/Typ.vue";
import TypMetlifeOK from "~/components/typ/TypMetlifeOK.vue";

export default {
    Loading,
    PrecompiledData,
    PrecompiledDocument,
    IdentityDocData,
    IncomeData,
    EmployerData,
    LoanProtection,
    LoanProtectionConsent,
    LoanProtectionWarning,
    ClubConsent,
    ClubWarning,
    PersonalData,
    Promo,
    PromoConfirm,
    PromoTerms,
    MetlifeProtection,
    MetlifeProtectionConsent,
    MetlifeProtectionWarning,
    RequestKO,
    RequestPending,
    RequestExpired,
    Typ,
    TypMetlifeOK
}